export const LAMINATE_CALCULATOR_IDS = [
  '66d04df7c1480f7c1f38d2c0',
  '66d0448a206ce857b374a704',
  '66d043db0f8f5b1e368859e6',
];
export const FLOOR_IDS = [
  '66d04df7c1480f7c1f38d2c0',
  '66d04da7c1480f7c1f38d2bf',
  '66c881789049db696fcd368b',
  '63bd2ec3365ff20bc7b474c8',
  '66d0448a206ce857b374a704',
  '66d043db0f8f5b1e368859e6',
];
